import { render, staticRenderFns } from "./KeyDescFooter.vue?vue&type=template&id=a5cf5f8a"
import script from "./KeyDescFooter.vue?vue&type=script&lang=js"
export * from "./KeyDescFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports